<script setup lang="ts">
import TagList from './../tag-list/TagList.vue'

import type { StructureTermTreeParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  structureTermTree: StructureTermTreeParagraph['structureTermTree']
}>()
</script>

<template>
  <TagList :tag-list="structureTermTree" />
</template>
